import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import type {
  CounselingCenterStatistics,
  CounselingCenterNumberOfStatistic,
} from '../../../common/types/statistics/fhbfStatistics';

const statisticsOrder: {
  key: keyof CounselingCenterNumberOfStatistic;
  label: string;
}[] = [
  {
    key: 'totalNumber',
    label: 'Gesamtzahl der Klient*innen',
  },
  {
    key: 'numberOfAnonymous',
    label: 'Anzahl der Anonymen Klient*innen',
  },
  {
    key: 'numberOfChildren',
    label: 'Anzahl der Frauen mit minderjährigen Kindern',
  },
  {
    key: 'numberOfChildrenDirectViolence',
    label: 'Summe der von direkter Gewalt betroffenen Kinder',
  },
  {
    key: 'numberOfChildrenZeroToThreeYears',
    label: 'Anzahl der Kinder im Alter von 0 - 3 Jahre',
  },
  {
    key: 'numberOfChildrenFourToSixYears',
    label: 'Anzahl der Kinder im Alter von 4 - 6 Jahre',
  },
  {
    key: 'numberOfChildrenSevenToThirteenYears',
    label: 'Anzahl der Kinder im Alter von 7 - 13 Jahre',
  },
  {
    key: 'numberOfChildrenFourteenToSeventeenYears',
    label: 'Anzahl der Kinder im Alter von 14 - 17 Jahre',
  },
  {
    key: 'numberOfStabilizationGroup',
    label: 'Summe der Interesse Stabilisierungsgruppe',
  },
  {
    key: 'numberOfTraumaCounseling',
    label: 'Summe der Interesse an traumasensiblen Intensivangebot',
  },
];

type Props = {
  statistics: CounselingCenterStatistics;
};

function InformationStatistic({ statistics }: Props) {
  return (
    <Stack direction='column' mb={2}>
      {statisticsOrder.map(({ key, label }) => (
        <Typography key={key}>
          {label}: {statistics[key]}
        </Typography>
      ))}
    </Stack>
  );
}

export default InformationStatistic;
